var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trans_large",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46169",
    "data-name": "Path 46169",
    d: "M0,0H65V65H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46170",
    "data-name": "Path 46170",
    d: "M12.958,31.888,3.692,43.764a2.642,2.642,0,0,0,0,3.022l9.266,11.877c1.033,1.362,2.833.383,2.833-1.49V49.511H35.823c1.833,0,3.333-1.916,3.333-4.257S37.656,41,35.823,41H15.791v-7.62C15.791,31.462,13.991,30.526,12.958,31.888ZM61.32,18.223,52.055,6.347c-1.033-1.362-2.833-.383-2.833,1.49v7.62H29.157c-1.833,0-3.333,1.916-3.333,4.257s1.5,4.257,3.333,4.257H49.188v7.62c0,1.916,1.8,2.852,2.833,1.49L61.287,21.2a2.521,2.521,0,0,0,.033-2.98Z",
    transform: "translate(0 0)",
    fill: "#374955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransLarge);
export default __webpack_public_path__ + "static/media/trans_large.39ba4f5de10797deccf0190d2094e06f.svg";
export { ForwardRef as ReactComponent };